import React from 'react';
import { observer } from 'mobx-react-lite';
import { toChoiceQuestionAnswerOrEmpty } from '../../../stores/QuestionStore';
import { DisplayMode } from '../../RenderForm';
import { EditCascadingDropdown } from './edit';
import { ViewCascadingDropdown } from './view';
export var CascadingDropdown = observer(function (_ref) {
  var _questionStore$issueF;
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var availableParentOptions = questionStore.availableOptions();
  var currentParentOption = availableParentOptions.find(function (option) {
    var _currentAnswer$choice;
    return option.value === (currentAnswer === null || currentAnswer === void 0 || (_currentAnswer$choice = currentAnswer.choices) === null || _currentAnswer$choice === void 0 || (_currentAnswer$choice = _currentAnswer$choice[0]) === null || _currentAnswer$choice === void 0 ? void 0 : _currentAnswer$choice.split(':')[0]);
  });
  var availableChildOptions = currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.children;
  var currentChildOption = availableChildOptions === null || availableChildOptions === void 0 ? void 0 : availableChildOptions.find(function (option) {
    var _currentAnswer$choice2;
    return option.value === (currentAnswer === null || currentAnswer === void 0 || (_currentAnswer$choice2 = currentAnswer.choices) === null || _currentAnswer$choice2 === void 0 ? void 0 : _currentAnswer$choice2[0].split(':')[1]);
  });
  var showEditComponent = displayMode === DisplayMode.Edit && !((_questionStore$issueF = questionStore.issueFieldData) !== null && _questionStore$issueF !== void 0 && _questionStore$issueF.readOnlyReason);
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    var onChange = function onChange(value) {
      var selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      var newChoiceIds = selectedChoiceId ? [selectedChoiceId] : [];
      questionStore.setAnswer({
        choices: newChoiceIds
      });
    };
    var onChangeChild = function onChangeChild(value) {
      var selectedChoiceId = value === null || value === void 0 ? void 0 : value.value;
      var newChoiceIds = selectedChoiceId ? ["".concat(currentParentOption === null || currentParentOption === void 0 ? void 0 : currentParentOption.value, ":").concat(selectedChoiceId)] : [];
      questionStore.setAnswer({
        choices: newChoiceIds
      });
    };
    return /*#__PURE__*/React.createElement(EditCascadingDropdown, {
      id: id,
      errorId: errorId,
      descriptionId: descriptionId,
      key: "".concat(id, "-").concat(questionStore.dependentFieldChangedCount),
      options: availableParentOptions,
      value: currentParentOption,
      childOptions: availableChildOptions,
      childValue: currentChildOption,
      loading: questionStore.loading,
      onChange: onChange,
      onChangeChild: onChangeChild,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewCascadingDropdown, {
    id: id,
    value: currentParentOption,
    childValue: currentChildOption,
    displayMode: displayMode
  });
});